export default { notificationsWireToInt };

function notificationsWireToInt (wireNotifications) {
  if (!wireNotifications || !wireNotifications.notification) return [];

  let intNotifications = [];
  wireNotifications = wireNotifications.notification;
  if (wireNotifications.length) {
    for (let i = 0; i < wireNotifications.length; i++) {
      intNotifications.push(notificationWireToInt(wireNotifications[ i ]));
    }
  } else {
    intNotifications.push(notificationWireToInt(wireNotifications));
  }
  return intNotifications;
}

function notificationWireToInt (wireNotification) {
  const { title, type, description, url } = wireNotification;
  return {
    title: title._text,
    type: type._text,
    description: description._text,
    url: url._cdata,
  };
}



// WEBPACK FOOTER //
// ./src/converter/NotificationsConverter.js